export const debounce = (func: () => void, wait: number) => {
  let timeout: NodeJS.Timer | number | null;

  return function() {
    let later = () => {
      timeout = null;
      func();
    };
    let callNow = !timeout;
    clearTimeout(timeout as number);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func();
    }
  };
};
